module.exports = __webpack_public_path__ + "static/media/empty-colors.64633972.svg";